import Keycloak from "keycloak-js";

const roleSuffix = import.meta.env.VITE_ROLE_SUFFIX ?? "";

export const UserRoles = {
    EW_ADMIN: `ewsInsuranceAdministratorRole${roleSuffix}`,
    EW_ACCOUNTING: `ewsAccountingEmployeeRole${roleSuffix}`,
    EW_ADMIN_READONLY: `ewsReadOnlyRole${roleSuffix}`,
    EW_DEBTOR: `ewsReadOnlyAccountingEmployeeRole${roleSuffix}`,
    NONE: "none",
} as const;

export type UserRoles = (typeof UserRoles)[keyof typeof UserRoles];

export type UserInfo = Readonly<{
    token?: string;
    keycloak?: Keycloak;
    userName?: string;
    userRole?: UserRoles;
    email?: string;
}>;

export enum PaidStatus {
    PAID = "PAID",
    UNPAID = "UNPAID",
}
